import { useEffect, useState } from "react";

import { API_GET_OPEN_TIMESHEET_EMPLOYEES } from "../../../../../config/Endpoints.js";
import { getApi } from "../../../../utils/api.ts";
import { accessToken } from "../../../../utils/auth.ts";

type OpenTimesheetResponse = number[] | { data?: number[] };

function extractEmployeeIds(response: OpenTimesheetResponse): number[] {
  const values = Array.isArray(response) ? response : response.data ?? [];
  return values.map(Number).filter(Number.isFinite);
}

export function useOpenTimesheetEmployee(
  employeeId: number | undefined,
): boolean {
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const controller = new AbortController();

    async function checkAccess() {
      if (employeeId == null) {
        setHasAccess(false);
        return;
      }

      try {
        const { data } = await getApi<OpenTimesheetResponse>(
          API_GET_OPEN_TIMESHEET_EMPLOYEES,
          accessToken(),
          "json",
          controller.signal,
        );
        setHasAccess(extractEmployeeIds(data).includes(Number(employeeId)));
      } catch {
        if (!controller.signal.aborted) setHasAccess(false);
      }
    }

    void checkAccess();
    return () => controller.abort();
  }, [employeeId]);

  return hasAccess;
}
